var map = {
	"./0.gif": "ccf76",
	"./1.gif": "161e",
	"./2.gif": "e6ab",
	"./3.gif": "fb78",
	"./4.gif": "9ee0",
	"./5.gif": "b9b0",
	"./6.gif": "d476",
	"./7.gif": "a7eb4",
	"./8.gif": "fa299",
	"./9.gif": "761d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6de4";